



























import Vue from 'vue'
import moment from 'moment'
import { Button } from 'element-ui'
import './CountdownTimer.scss'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

export default Vue.extend({
  name: 'CountdownTimer',
  props: {
    eventEndTime: {
      type: Number,
      required: true
    }
  },
  computed: {
    canSeeTimer (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Cast)
    }
  },
  watch: {
    eventEndTime: {
      handler () {
        this.startTimer()
      },
      immediate: true
    },
    almostOver (newVal: boolean, oldVal: boolean) {
      if (newVal === true && oldVal === false) {
        this.showPopup = true
      } else if (newVal === false && oldVal === true) {
        this.showPopup = false
      }
    }
  },
  data: () => ({
    timer: null as null|NodeJS.Timeout,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    difference: 0,
    almostOver: false,
    eventOver: false,
    countDownDate: 0,
    showPopup: false
  }),
  created () {
    this.startTimer()
  },
  beforeDestroy () {
    this.stopTimer()
  },
  components: {
    'el-button': Button
  },
  methods: {
    startTimer () {
      this.stopTimer()
      this.countDownDate = moment.unix(this.eventEndTime).unix() * 1000
      //
      this.timer = setInterval(() => {
        const now = new Date().getTime()
        // Find the difference between now and the count down date
        this.difference = this.countDownDate - now
        // Time calculations for days, hours, minutes and seconds
        this.days = Math.floor(this.difference / (1000 * 60 * 60 * 24))
        this.hours = Math.floor((this.difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.minutes = Math.floor((this.difference % (1000 * 60 * 60)) / (1000 * 60))
        this.seconds = Math.floor((this.difference % (1000 * 60)) / 1000)
        // If the count down is finished
        if (this.difference <= 0) {
          this.stopTimer()
          this.eventOver = true
          this.$emit('expired')
        } else if (this.difference < 600000) {
          this.almostOver = true
        } else {
          this.almostOver = false
          this.eventOver = false
        }
      }, 1000)
    },
    stopTimer () {
      if (this.timer !== null) {
        clearInterval(this.timer)
      }
    },
    extendEvent () {
      this.$emit('extendEvent')
      this.showPopup = false
    }
  }
})
